import React, { useMemo } from 'react';
import { ChartPropertyType } from '../statisticsModalChartLib';
import { StatisticsModalType } from '../../statisticsLib';
import StatisticsModalChartTooltip from '../StatisticsModalChartTooltip';
import { StatisticsModalChart } from '../StatisticsModalChart';
import { Spin } from 'antd';
import { useGetStatsTargetStoresQuery } from '../../apiCalculationStatistics';
import { useSelector } from 'react-redux';
import { ReduxState } from '../../../../../store';
import { useApplicationData } from '../../../../../hooks/useApplicationData';
import { CalculationStatisticClusterType } from '@ydistri/api-sdk';

interface StatisticsModalChartTargetStoreProps {
  chartValueType: ChartPropertyType<StatisticsModalType.TARGET_STORE>;
  calculationId: number;
}

const StatisticsModalChartTargetStore: React.FC<StatisticsModalChartTargetStoreProps> = ({
  chartValueType,
  calculationId,
}) => {
  const departmentId = useSelector((state: ReduxState) => state.statistics.departmentId);
  const { departments: hasDepartments } = useApplicationData();
  const clusterType = useSelector((state: ReduxState) => state.statistics.clusterType);
  const showDepartments =
    hasDepartments && clusterType === CalculationStatisticClusterType.StoreDepartment;

  const { data: targetStoreData, isFetching } = useGetStatsTargetStoresQuery({
    calculationId,
    departmentId,
    tableOrChart: 'chart',
    skip: 0,
    clusterType,
  });

  const data = useMemo(() => targetStoreData ?? [], [targetStoreData]);

  const customTooltipId = 'chartjs-tooltip-target-store';

  return (
    <Spin spinning={isFetching}>
      <StatisticsModalChart
        statisticsModalType={StatisticsModalType.TARGET_STORE}
        customTooltipId={customTooltipId}
        chartValueType={chartValueType}
        data={data}
      />
      <StatisticsModalChartTooltip
        modalType={StatisticsModalType.TARGET_STORE}
        showDepartments={showDepartments}
        chartValueType={chartValueType}
        customTooltipId={customTooltipId}
      />
    </Spin>
  );
};

export default StatisticsModalChartTargetStore;
